import { Component, OnInit, Inject } from '@angular/core';
import { Category } from '../../../shared/models/Category';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-category-selection-dialog',
  templateUrl: './category-selection-dialog.component.html',
  styleUrls: ['./category-selection-dialog.component.scss'],
})
export class CategorySelectionDialogComponent implements OnInit {
  categories: Category[];
  kidsModule: boolean;

  constructor(
    public dialogRef: MatDialogRef<CategorySelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService
  ) {
    this.categories = data.categories as Category[];
    this.kidsModule = data.kidsModule as boolean;
  }

  ngOnInit() {}

  choose(category: Category) {
    this.dialogRef.close(category);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/category-selection-dialog/category-selection-dialog.component.ts